(() => {
  const popup = document.querySelector('.bf-cart-confirmation');
  if (!popup || popup.dataset.initialized) return;
  popup.dataset.initialized = 'true';
  const body = document.body;
  const title = popup.querySelector('.title');
  const status = document.querySelector('[data-bf-cart-confirmation-status]');
  const heading = popup.querySelector('.bf-cart-confirmation-heading').textContent.trim();
  let timer;
  let open = false;
  let hovered = false;
  let announcement = 0;
  let opener;

  const clear = () => window.clearTimeout(timer);
  const close = () => body.classList.remove('add-to-cart-show');
  const restart = () => {
    clear();
    if (open && !hovered && !popup.contains(document.activeElement)) {
      timer = window.setTimeout(close, 3000);
    }
  };
  const position = () => {
    const cart = [...document.querySelectorAll('[data-cart-sidebar]')].find(element => {
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.top >= 0 && rect.bottom < Math.min(260, window.innerHeight / 2);
    });
    const top = cart ? cart.getBoundingClientRect().bottom + 12 : 16;
    popup.style.setProperty('--bf-cart-confirmation-top', `${Math.round(top)}px`);
  };
  const sync = (updated = false) => {
    let next = body.classList.contains('add-to-cart-show');
    if (next && body.classList.contains('cart-sidebar-show')) {
      close();
      next = false;
    }
    if (next === open && !updated) return;
    if (next && !open) opener = document.activeElement;
    open = next;
    popup.setAttribute('aria-hidden', String(!open));
    const sequence = ++announcement;
    if (!open) {
      clear();
      if (status) status.textContent = '';
      if (popup.contains(document.activeElement) && opener?.isConnected) opener.focus({ preventScroll: true });
      return;
    }
    position();
    restart();
    if (status) {
      status.textContent = '';
      window.requestAnimationFrame(() => {
        if (open && sequence === announcement) status.textContent = `${heading}: ${title.textContent.trim()}`;
      });
    }
  };

  new MutationObserver(() => sync()).observe(body, { attributes: true, attributeFilter: ['class'] });
  new MutationObserver(() => sync(true)).observe(title, { childList: true, characterData: true, subtree: true });
  popup.addEventListener('pointerenter', event => {
    if (event.pointerType !== 'mouse') return;
    hovered = true;
    clear();
  });
  popup.addEventListener('pointerleave', () => {
    hovered = false;
    restart();
  });
  popup.addEventListener('focusin', clear);
  popup.addEventListener('focusout', () => window.setTimeout(restart, 0));
  popup.querySelector('[data-close-add-to-cart-popup]').addEventListener('click', close);
  document.addEventListener('keydown', event => {
    if (open && event.key === 'Escape') close();
  });
  window.addEventListener('resize', () => { if (open) position(); }, { passive: true });
  sync();
})();
